import {
  getOrCreateDirectConversation as getOrCreateDirectConversationService,
  createGroupConversation as createGroupConversationService,
  getUserConversations as getUserConversationsService,
  sendChatMessage as sendChatMessageService,
  getConversationMessages as getConversationMessagesService,
  markConversationAsRead as markConversationAsReadService,
} from "services/company/chat/chatService";
import {
  fetchConversationsStart,
  fetchConversationsSuccess,
  fetchConversationsFailure,
  fetchMessagesStart,
  fetchMessagesSuccess,
  fetchMessagesFailure,
  sendMessageStart,
  sendMessageSuccess,
  sendMessageFailure,
  markReadSuccess,
  setActiveConversation,
} from "./chatSlice";
import { showErrorToast } from "utils/toastNotification";

// Fetch user's active conversations list
export const fetchUserConversations = () => async (dispatch) => {
  try {
    dispatch(fetchConversationsStart());
    const response = await getUserConversationsService();

    if (response?.meta?.status === true || Array.isArray(response?.data)) {
      const data = Array.isArray(response?.data) ? response.data : response;
      dispatch(fetchConversationsSuccess(data));
      return { success: true, data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch conversations";
      dispatch(fetchConversationsFailure(errorMsg));
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch conversations error:", error);
    const errorMsg = error?.response?.data?.meta?.message || error.message || "Failed to fetch conversations";
    dispatch(fetchConversationsFailure(errorMsg));
    return { success: false, error: errorMsg };
  }
};

// Get or Create Direct Conversation
export const getOrCreateDirectConversationThunk = (recipientData) => async (dispatch) => {
  try {
    const response = await getOrCreateDirectConversationService(recipientData);
    const convData = response?.data || response;

    if (convData && convData._id) {
      dispatch(setActiveConversation(convData));
      return { success: true, data: convData };
    } else {
      const errorMsg = response?.meta?.message || "Failed to start direct conversation";
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Direct conversation error:", error);
    const errorMsg = error?.response?.data?.meta?.message || error.message || "Failed to start conversation";
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Fetch Conversation Messages
export const fetchConversationMessagesThunk = (conversationId, params = {}) => async (dispatch) => {
  if (!conversationId) return { success: false };

  try {
    dispatch(fetchMessagesStart());
    const response = await getConversationMessagesService(conversationId, params);
    const resData = response?.data || response;

    let fetchedMessages = [];
    if (Array.isArray(resData?.messages)) {
      fetchedMessages = resData.messages;
    } else if (Array.isArray(resData)) {
      fetchedMessages = resData;
    }

    dispatch(fetchMessagesSuccess({ conversationId, messages: fetchedMessages }));
    return { success: true, data: fetchedMessages };
  } catch (error) {
    console.error("Fetch conversation messages error:", error);
    const errorMsg = error?.response?.data?.meta?.message || error.message || "Failed to fetch messages";
    dispatch(fetchMessagesFailure(errorMsg));
    return { success: false, error: errorMsg };
  }
};

// Send Message
export const sendChatMessageThunk = (messageData) => async (dispatch) => {
  try {
    dispatch(sendMessageStart());
    const response = await sendChatMessageService(messageData);
    const resData = response?.data || response;
    const createdMsg = resData?.message || resData;

    if (createdMsg && createdMsg._id) {
      dispatch(sendMessageSuccess({ conversationId: messageData.conversationId, message: createdMsg }));
      return { success: true, data: createdMsg };
    } else {
      const errorMsg = response?.meta?.message || "Failed to send message";
      dispatch(sendMessageFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Send chat message error:", error);
    const errorMsg = error?.response?.data?.meta?.message || error.message || "Failed to send message";
    dispatch(sendMessageFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Mark Messages as Read
export const markConversationReadThunk = (conversationId) => async (dispatch) => {
  try {
    await markConversationAsReadService(conversationId);
    dispatch(markReadSuccess(conversationId));
    return { success: true };
  } catch (error) {
    console.error("Mark read error:", error);
    return { success: false };
  }
};

// Create Group Conversation
export const createGroupConversationThunk = (groupData) => async (dispatch) => {
  try {
    const response = await createGroupConversationService(groupData);
    const group = response?.data || response;
    if (group && group._id) {
      dispatch(setActiveConversation(group));
      return { success: true, data: group };
    } else {
      const errorMsg = response?.meta?.message || "Failed to create group";
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Create group error:", error);
    const errorMsg = error?.response?.data?.meta?.message || error.message || "Failed to create group";
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};
